module.exports = __webpack_public_path__ + "media/waiterishere.7de5b072.mp3";